<template>
  <p class="clearfix mb-0">
    <!-- <span class="float-md-left d-block d-md-inline-block mt-25">
      COPYRIGHT  © {{ new Date().getFullYear() }}
      <b-link
        class="ml-25"
        href="https://1.envato.market/pixinvent_portfolio"
        target="_blank"
      >Pixinvent</b-link>
      <span class="d-none d-sm-inline-block">, All rights Reserved</span>
    </span> -->

    <span class="d-none d-md-block text-center">
      <a href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备2023042916号</a> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      SLQ &amp; Made with
      <feather-icon
        icon="HeartIcon"
        size="21"
        class="text-danger stroke-current"
      />
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
